export const state = {
  modalViewInvestment: false,
  investments: [],
  investment: {},
  payInvestment: {},
  listPayInvestments: []
};

export default {};
